import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar, Toolbar, makeStyles, Typography
} from '@material-ui/core';

const useStyles = makeStyles({
  root: {},
  toolbar: {
    height: 64
  },
  title: {
    color: '#fff',
    fontSize: '1.5rem'
  }
});

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          <Typography className={classes.title} variant="h1">
            Biblioteca Virtual
          </Typography>
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string
};

export default TopBar;
